// AUTOGENERATED FILE - DO NOT EDIT

/**
 * All IAM policy actions for AWS HealthLake (HEALTHLAKE)
 *
 * Extracted by `aws-iam-policy` from
 * https://docs.aws.amazon.com/service-authorization/latest/reference/list_awshealthlake.html
 *
 * 2025-02-24T21:48:11.240Z
 */
export enum AwsHealthlakeActions {
  /**
   * Grants permission to cancel an on going FHIR Export job with Delete
   *
   * See https://docs.aws.amazon.com/healthlake/latest/devguide/export-datastore-rest.html
   */
  CancelFHIRExportJobWithDelete = 'healthlake:CancelFHIRExportJobWithDelete',
  /**
   * Grants permission to create a datastore that can ingest and export FHIR data
   *
   * See https://docs.aws.amazon.com/healthlake/latest/APIReference/API_CreateFHIRDatastore.html
   */
  CreateFHIRDatastore = 'healthlake:CreateFHIRDatastore',
  /**
   * Grants permission to create resource
   *
   * See https://docs.aws.amazon.com/healthlake/latest/devguide/crud-healthlake.html
   */
  CreateResource = 'healthlake:CreateResource',
  /**
   * Grants permission to delete a datastore
   *
   * See https://docs.aws.amazon.com/healthlake/latest/APIReference/API_DeleteFHIRDatastore.html
   */
  DeleteFHIRDatastore = 'healthlake:DeleteFHIRDatastore',
  /**
   * Grants permission to delete resource
   *
   * See https://docs.aws.amazon.com/healthlake/latest/devguide/crud-healthlake.html
   */
  DeleteResource = 'healthlake:DeleteResource',
  /**
   * Grants permission to get the properties associated with the FHIR datastore, inc
   * luding the datastore ID, datastore ARN, datastore name, datastore status, creat
   * ed at, datastore type version, and datastore endpoint
   *
   * See https://docs.aws.amazon.com/healthlake/latest/APIReference/API_DescribeFHIRDatastore.html
   */
  DescribeFHIRDatastore = 'healthlake:DescribeFHIRDatastore',
  /**
   * Grants permission to display the properties of a FHIR export job, including the
   * ID, ARN, name, and the status of the datastore
   *
   * See https://docs.aws.amazon.com/healthlake/latest/APIReference/API_DescribeFHIRExportJob.html
   */
  DescribeFHIRExportJob = 'healthlake:DescribeFHIRExportJob',
  /**
   * Grants permission to display the properties of a FHIR export job, including the
   * ID, ARN, name, and the status of the datastore with Get
   *
   * See https://docs.aws.amazon.com/healthlake/latest/devguide/export-datastore-rest.html
   */
  DescribeFHIRExportJobWithGet = 'healthlake:DescribeFHIRExportJobWithGet',
  /**
   * Grants permission to display the properties of a FHIR import job, including the
   * ID, ARN, name, and the status of the datastore
   *
   * See https://docs.aws.amazon.com/healthlake/latest/APIReference/API_DescribeFHIRImportJob.html
   */
  DescribeFHIRImportJob = 'healthlake:DescribeFHIRImportJob',
  /**
   * Grants permission to get the capabilities of a FHIR datastore
   *
   * See https://docs.aws.amazon.com/healthlake/latest/devguide/crud-healthlake.html
   */
  GetCapabilities = 'healthlake:GetCapabilities',
  /**
   * Grants permission to access exported files from a FHIR Export job initiated wit
   * h Get
   *
   * See https://docs.aws.amazon.com/healthlake/latest/devguide/export-datastore-rest.html
   */
  GetExportedFile = 'healthlake:GetExportedFile',
  /**
   * Grants permission to read resource history
   *
   * See https://docs.aws.amazon.com/healthlake/latest/devguide/crud-healthlake.html
   */
  GetHistoryByResourceId = 'healthlake:GetHistoryByResourceId',
  /**
   * Grants permission to list all FHIR datastores that are in the user's account, r
   * egardless of datastore status
   *
   * See https://docs.aws.amazon.com/healthlake/latest/APIReference/API_ListFHIRDatastores.html
   */
  ListFHIRDatastores = 'healthlake:ListFHIRDatastores',
  /**
   * Grants permission to get a list of export jobs for the specified datastore
   *
   * See https://docs.aws.amazon.com/healthlake/latest/APIReference/API_ListFHIRExportJobs.html
   */
  ListFHIRExportJobs = 'healthlake:ListFHIRExportJobs',
  /**
   * Grants permission to get a list of import jobs for the specified datastore
   *
   * See https://docs.aws.amazon.com/healthlake/latest/APIReference/API_ListFHIRImportJobs.html
   */
  ListFHIRImportJobs = 'healthlake:ListFHIRImportJobs',
  /**
   * Grants permission to get a list of tags for the specified datastore
   *
   * See https://docs.aws.amazon.com/healthlake/latest/APIReference/API_ListTagsForResource.html
   */
  ListTagsForResource = 'healthlake:ListTagsForResource',
  /**
   * Grants permission to read resource
   *
   * See https://docs.aws.amazon.com/healthlake/latest/devguide/crud-healthlake.html
   */
  ReadResource = 'healthlake:ReadResource',
  /**
   * Grants permission to search all resources related to a patient
   *
   * See https://docs.aws.amazon.com/healthlake/latest/devguide/search-healthlake.html
   */
  SearchEverything = 'healthlake:SearchEverything',
  /**
   * Grants permission to search resources with GET method
   *
   * See https://docs.aws.amazon.com/healthlake/latest/devguide/search-healthlake.html
   */
  SearchWithGet = 'healthlake:SearchWithGet',
  /**
   * Grants permission to search resources with POST method
   *
   * See https://docs.aws.amazon.com/healthlake/latest/devguide/search-healthlake.html
   */
  SearchWithPost = 'healthlake:SearchWithPost',
  /**
   * Grants permission to begin a FHIR Export job
   *
   * See https://docs.aws.amazon.com/healthlake/latest/APIReference/API_StartFHIRExportJob.html
   */
  StartFHIRExportJob = 'healthlake:StartFHIRExportJob',
  /**
   * Grants permission to begin a FHIR Export job with Get
   *
   * See https://docs.aws.amazon.com/healthlake/latest/devguide/export-datastore-rest.html
   */
  StartFHIRExportJobWithGet = 'healthlake:StartFHIRExportJobWithGet',
  /**
   * Grants permission to begin a FHIR Export job with Post
   *
   * See https://docs.aws.amazon.com/healthlake/latest/devguide/export-datastore-rest.html
   */
  StartFHIRExportJobWithPost = 'healthlake:StartFHIRExportJobWithPost',
  /**
   * Grants permission to begin a FHIR Import job
   *
   * See https://docs.aws.amazon.com/healthlake/latest/APIReference/API_StartFHIRImportJob.html
   */
  StartFHIRImportJob = 'healthlake:StartFHIRImportJob',
  /**
   * Grants permission to add tags to a datastore
   *
   * See https://docs.aws.amazon.com/healthlake/latest/APIReference/API_TagResource.html
   */
  TagResource = 'healthlake:TagResource',
  /**
   * Grants permission to remove tags associated with a datastore
   *
   * See https://docs.aws.amazon.com/healthlake/latest/APIReference/API_UntagResource.html
   */
  UntagResource = 'healthlake:UntagResource',
  /**
   * Grants permission to update resource
   *
   * See https://docs.aws.amazon.com/healthlake/latest/devguide/crud-healthlake.html
   */
  UpdateResource = 'healthlake:UpdateResource',
  /**
   * Grants permission to read version of a resource
   *
   * See https://docs.aws.amazon.com/healthlake/latest/devguide/crud-healthlake.html
   */
  VersionReadResource = 'healthlake:VersionReadResource',
}
